import {
  FeedbackMode,
  FeedbackRequestStatus,
} from "../types/feedback/FeedbackRequestDto";

const LEGACY_NUMERIC_FEEDBACK_MODE: Record<number, FeedbackMode> = {
  0: "NONE",
  1: "FEEDBACKONLY",
  2: "FULLREVIEWACCESS",
  3: "SUBJECTEMPLOYEECHOICE",
};

const LEGACY_NUMERIC_FEEDBACK_REQUEST_STATUS: Record<
  number,
  FeedbackRequestStatus
> = {
  0: "PENDING",
  1: "SUBMITTED",
  2: "DELETED",
};

function parseLegacyNumericString(value: string): number | null {
  if (!/^\d+$/.test(value)) {
    return null;
  }
  return parseInt(value, 10);
}

/** Normalizes API feedback mode values (string wire format or legacy numeric) for comparisons. */
export function normalizeFeedbackMode(value: unknown): FeedbackMode {
  if (typeof value === "number") {
    return LEGACY_NUMERIC_FEEDBACK_MODE[value] ?? "NONE";
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return "NONE";
    }

    const legacyNumeric = parseLegacyNumericString(trimmed);
    if (legacyNumeric !== null) {
      return LEGACY_NUMERIC_FEEDBACK_MODE[legacyNumeric] ?? "NONE";
    }

    const upper = trimmed.toUpperCase();
    if (
      upper === "SUBJECTEMPLOYEECHOICE" ||
      upper === "SUBJECTEMPLOYEEECHOICE"
    ) {
      return "SUBJECTEMPLOYEECHOICE";
    }
    if (
      upper === "NONE" ||
      upper === "FEEDBACKONLY" ||
      upper === "FULLREVIEWACCESS"
    ) {
      return upper as FeedbackMode;
    }
  }

  return "NONE";
}

/** Normalizes feedback request status (string wire format or legacy numeric). */
export function normalizeFeedbackRequestStatus(
  value: unknown
): FeedbackRequestStatus {
  if (typeof value === "number") {
    return LEGACY_NUMERIC_FEEDBACK_REQUEST_STATUS[value] ?? "PENDING";
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return "PENDING";
    }

    const legacyNumeric = parseLegacyNumericString(trimmed);
    if (legacyNumeric !== null) {
      return (
        LEGACY_NUMERIC_FEEDBACK_REQUEST_STATUS[legacyNumeric] ?? "PENDING"
      );
    }

    const upper = trimmed.toUpperCase();
    if (
      upper === "PENDING" ||
      upper === "SUBMITTED" ||
      upper === "DELETED"
    ) {
      return upper as FeedbackRequestStatus;
    }
  }

  return "PENDING";
}

export function isActiveFeedbackRequestStatus(value: unknown): boolean {
  return normalizeFeedbackRequestStatus(value) !== "DELETED";
}

export default normalizeFeedbackMode;
